<template>
<vx-card fixed-height="true">
    <div>
        <vs-button v-if="userRoot" line-position="top" line-origin="left" color="success" type="line" class="mr-2" @click="getNuevo()">Agregar Nuevo Producto</vs-button>
        <vs-button v-if="userRoot || groupBodega" line-position="top" line-origin="left" color="warning" type="line" class="mr-2 flex-align-items" @click="getEdicionMasivaStock()">Edición Masiva de Stock</vs-button>
        <vs-button v-if="userRoot || groupBodega" line-position="top" line-origin="left" color="gray" type="line" class="mr-2 flex-align-items" @click="getReporteProductos()">Reporte Productos</vs-button>
        <vs-button v-if="userRoot || groupBodega" line-position="top" line-origin="left" color="primary" type="line" class="mr-2 flex-align-items" @click="HistoricoEdicionMasivaStock()">Histórico Stock</vs-button>
        <vs-button v-if="userRoot" line-position="top" line-origin="left" color="rgb(100, 59, 202)" type="line" class="mr-2 flex-align-items" @click="abrirModalSincronizarPerseo()">🔄 Vincular / Sincronizar Perseo</vs-button>
        <vs-button v-if="userRoot || AsisGerencia || groupBodega" color="dark" type="border" icon="info" @click="getInformacionProducto()" style="float: right" title="Información">Información</vs-button>
    </div>
    <vs-row vs-justify="flex-start">
        <vs-col type="flex" vs-justify="flex-start" vs-align="flex-start" class="m-2" vs-w="12">
            <p>Búsqueda por filtros</p>
            <br>
            <!-- NORMAL: {{ userFacturador }}
            ADMIN: {{ userAdminFacturador }} -->
            <vs-card class="seccionmostrartodo">
                <div>
                    <vs-input v-if="valorBusqueda != '2' && valorBusqueda != '3'" class="w-full" @keyup.enter="getProductoParametro()" icon-after="true" label-placeholder="icon-after" style="margin:0px 0px 20px 0px;" icon="search" placeholder="Buscar" v-model="busquedaxcodigo" />
                </div>
                <div>
                    <ul class="leftx" style="display:flex;margin:0px 0px 0px 20px;">
                        <li class="modelx">
                        </li>
                        <li style="margin:10px 20px 0px 0px;">
                            <vs-radio vs-name="radios1" vs-value="0" v-model="valorBusqueda" @input="busqueda='codigopro'">Iniciales</vs-radio>
                        </li>
                        <li style="margin:10px 10px 0px 0px;">
                            <vs-radio vs-name="radios2" vs-value="1" v-model="valorBusqueda" @input="busqueda='nombres'">Nombres</vs-radio>
                        </li>
                        <li style="margin:10px 10px 0px 0px;" v-if="userRoot || AsisGerencia || groupBodega">
                            <vs-radio vs-name="radios2" vs-value="2" v-model="valorBusqueda" @input="getProductos_inactivos()">Mostrar inactivos</vs-radio>
                        </li>
                        <li style="margin:10px 10px 0px 0px;" v-if="userRoot || AsisGerencia || groupBodega">
                            <vs-radio vs-name="radios2" vs-value="3" v-model="valorBusqueda" @input="getProductos_stockminimo()">Productos con stock menor al mínimo</vs-radio>
                        </li>
                        <li>
                            <vs-button color="warning" type="filled" style="margin-left:10px;" @click="getProductoParametro();" icon="search"></vs-button>
                        </li>
                    </ul>
                </div>
            </vs-card>
        </vs-col>
    </vs-row>
    <vs-button color="success" @click="exportarCombos" icon class="mt-3" v-if="Productos.length > 0">
      📥 Exportar Excel
    </vs-button>
    <!-- <vs-button type="border" color="success" class="mr-2" @click="getNuevo()">Agregar Nuevo Producto</vs-button> -->
    <vs-table max-items="10" stripe pagination search :data="Productos">
        <template slot="header">
            <vs-chip color="primary">Cantidad: <b> {{ Productos.length }}</b></vs-chip>
        </template>
        <!-- {{cliCi}} -->
        <template slot="thead">
            <vs-th width="100">
                Código
            </vs-th>
            <vs-th colspan="2" width="500" style="text-align: center">
                Información Producto
            </vs-th>
            <vs-th>Estado</vs-th>
            <vs-th width="100" v-if="userRoot || AsisGerencia || groupBodega">
                Acciones
            </vs-th>
        </template>
        <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].pro_codigo">
                    {{ data[indextr].pro_codigo }}
                </vs-td>
                <vs-td>
                   <!--   {{ tr }}-->
                    <small><b>Grupo:</b> {{tr.gru_pro_nombre}} </small><br>
                    <small><b>Nombres:</b> {{tr.pro_nombre}}</small><br>
                    <small><b>Descripción:</b> {{tr.pro_descripcion}}</small><br>
                    <small v-if="tr.id_pro_codigo_padre"><b>Producto padre:</b> {{tr.id_pro_codigo_padre}} - {{ tr.nombre_producto_padre }}</small><br>
                    <small v-if="tr.grupo_codigo_para_v3"><b>Grupo para vue 3:</b> {{tr.nombre_grupo_v3}}</small><br>
                    <small v-if="tr.codigos_combos"><b>Códigos del combo:</b> {{tr.codigos_combos}}</small>
                    <div v-if="userRoot || AsisGerencia || groupBodega">
                        <small><b>Iva:</b>
                            <template v-if="data[indextr].pro_iva == 1">
                                Si
                            </template>
                            <template v-else-if="data[indextr].pro_iva == 0">
                                No
                            </template>
                            <template v-else-if="data[indextr].pro_iva == null">
                                Vacio
                            </template>
                        </small><br>
                    </div>
                    <div v-if="userRoot || AsisGerencia || groupBodega">
                        <small><b>Valor:</b> {{tr.pro_valor}}</small><br>
                    </div>
                    <div v-if="userRoot || AsisGerencia || groupBodega">
                        <small><b>Descuento:</b> {{tr.pro_descuento}}</small><br>
                    </div>
                    <div v-if="userRoot || AsisGerencia || groupBodega">
                        <small><b>Peso:</b> {{tr.pro_peso}}</small><br>
                    </div>
                </vs-td>
                <vs-td>
                    <div v-if="userRoot || AsisGerencia || groupBodega">
                      <small><b>Costo:</b> {{tr.pro_costo}}</small>
                    </div>
                    <div v-if="tr.gru_pro_codigo == 1">
                      <small><b>Serie:</b> {{tr.nombre_serie}}</small><br>
                    </div>
                    <small :class="getStockClass(tr.pro_reservar, 1)">Stock General: {{ tr.pro_reservar }}</small><br>
                    <small :class="getStockClass(tr.pro_stock, 2)">Stock Facturas Prolipa: {{ tr.pro_stock }}</small><br>
                    <small :class="getStockClass(tr.pro_deposito, 4)">Stock Notas Prolipa: {{ tr.pro_deposito }}</small><br>
                    <small :class="getStockClass(tr.pro_stockCalmed, 3)">Stock Facturas Calmed: {{ tr.pro_stockCalmed }}</small><br>
                    <small :class="getStockClass(tr.pro_depositoCalmed, 5)">Stock Notas Calmed: {{ tr.pro_depositoCalmed }}</small><br>
                </vs-td>
                <vs-td>
                    <vs-chip v-if="tr.pro_estado == 1" color="success">Activo</vs-chip>
                    <vs-chip v-else color="danger">Inactivo</vs-chip>
                </vs-td>
                <vs-td :data="data[indextr].pro_codigo" v-if="userRoot || AsisGerencia || groupBodega">
                    <vs-dropdown vs-custom-content vs-trigger-click title="Opciones">
                        <vs-button class="a-icons" href.prevent icon="more_vert" type="border"></vs-button>
                        <vs-dropdown-menu style="width: 250px;" class="cursor">
                            <vs-dropdown-item>
                                <vs-button v-if="tr.pro_estado == 1" color="#28C76F" type="line" class="w-full" @click="popupActivo=true;getEditar(tr)">Editar</vs-button>
                                <vs-button v-if="tr.pro_estado == 1" color="#EA5455" type="line" class="w-full" @click="popupActivo=true;popup_desactivar_activar_producto(tr)">Desactivar producto</vs-button>
                                <vs-button v-if="tr.pro_estado == 0" color="#28C76F" type="line" class="w-full" @click="popupActivo=true;popup_desactivar_activar_producto(tr)">Activar producto</vs-button>
                                <vs-button color="#EA5455" type="line" class="w-full" @click="popupActivo=true;getPreguntaEliminar(tr)">Eliminar</vs-button>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </vs-td>
            </vs-tr>
        </template>
    </vs-table>
    <!-- SECCION REGISTRO -->
    <vs-popup class="crear" title="Registro nuevo producto" :active.sync="popupActivoGuardar">
        <vs-row>
            <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" style="text-align: center;"><b>Información Producto</b></vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
              <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                <vs-col vs-justify="center" vs-align="center" vs-w="11">
                    <font style="font-size: 11.5px">&nbsp;Producto padre</font><br>
                    <v-select :options="arrayTextosSinCombos" :reduce="arrayTextosSinCombos => arrayTextosSinCombos.pro_codigo" label="pro_codigo_nombre" class="w-full h-100" :class="{ 'input-error': errorPadreGuardar }" placeholder="--Seleccione--" v-model="tabProducto.id_pro_codigo_padre" />
                    <span v-if="errorPadreGuardar" style="color: red; font-size: 11.5px;">Seleccione un producto padre</span>
                    <small class="text-danger">No seleccionar si es un producto padre como manantial lengua 2 (solo si es folleto, cuaderno, guia)</small>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="11">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <font style="font-size: 11.5px">&nbsp;Grupo</font><br>
                        <v-select :options="Grupos" :reduce="Grupos => Grupos.gru_pro_codigo" label="gru_pro_nombre" class="w-full h-100" placeholder="--Seleccione--" v-model="tabProducto.gru_pro_codigo" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Código del producto " maxlength="7" placeholder="Nombre" class="w-full" icon="mode_edit" v-model="tabProducto.pro_codigo" @input="convertirAMayusculas()" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
              <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                <vs-col vs-justify="center" vs-align="center" vs-w="10">
                    <font style="font-size: 11.5px">&nbsp;Grupo para v3</font><br>
                        <v-select :options="Grupos" :reduce="Grupos => Grupos.gru_pro_codigo" label="gru_pro_nombre" class="w-full h-100" :class="{ 'input-error': errorGrupoV3Guardar }" placeholder="--Seleccione--" v-model="tabProducto.grupo_codigo_para_v3" @input="handleSelectInputGuardar" />
                    <span v-if="errorGrupoV3Guardar" style="color: red; font-size: 11.5px;">Seleccione un grupo para v3</span>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col v-if="tabProducto.gru_pro_codigo === 1 || tabProducto.gru_pro_codigo === 3 || tabProducto.gru_pro_codigo === 6" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <font style="font-size: 11.5px">&nbsp;Serie</font><br>
                        <v-select :options="series" :reduce="series => series.id_serie" label="nombre_serie" placeholder="--Seleccione--" class="w-full" v-model="tabProducto.id_serie" />
                        <span v-if="!tabProducto.id_serie" style="color: red; font-size: 11.5px;">Este campo es obligatorio</span>
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Nombre " placeholder="Nombre" class="w-full" icon="mode_edit" v-model="tabProducto.pro_nombre" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Descripción " placeholder="Descripción" class="w-full" icon="mode_edit" v-model="tabProducto.pro_descripcion" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <!-- <vs-input label="Iva *" type="number" placeholder="Iva" class="w-full" icon="mode_edit" v-model="tabProducto.proIva" /> -->
                        <font style="font-size: 11.5px">&nbsp;IVA *</font><br>
                        <v-select :options="options1" :reduce="options1 => options1.value" label="text" class="w-full h-100" placeholder="--Seleccione--" v-model="tabProducto.pro_iva" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Valor " type="number" placeholder="Valor" class="w-full" icon="mode_edit" v-model="tabProducto.pro_valor" @keypress="validarValor" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <font style="font-size: 11.5px; display: inline-flex;">&nbsp;Descuento * &emsp; Formato: 0.00</font><br>
                        <vs-input type="number" id="pro-descuento-input" placeholder="Descuento" class="w-full" icon="mode_edit" v-model="tabProducto.pro_descuento" @keypress="validarDescuento" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Costo " type="number" placeholder="Costo" class="w-full" icon="mode_edit" v-model="tabProducto.pro_costo" @keypress="validarCosto" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Peso " type="number" placeholder="Peso" class="w-full" icon="mode_edit" v-model="tabProducto.pro_peso" @keypress="validarPeso" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" style="text-align: center; margin-top: 10px;"><b>Bodega Prolipa</b></vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <vs-input label="Stock Facturas" type="number" placeholder="Stock Facturas" class="w-full" icon="mode_edit" v-model="tabProducto.pro_stock" @keypress="validarStock" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <vs-input label="Stock Notas" type="number" placeholder="Stock Notas" class="w-full" icon="mode_edit" v-model="tabProducto.pro_deposito" @keypress="validarStock" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" style="text-align: center; margin-top: 10px;"><b>Bodega Calmed</b></vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <vs-input label="Stock Facturas" type="number" placeholder="Stock Facturas" class="w-full" icon="mode_edit" v-model="tabProducto.pro_stockCalmed" @keypress="validarStock" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <vs-input label="Stock Notas" type="number" placeholder="Stock Notas" class="w-full" icon="mode_edit" v-model="tabProducto.pro_depositoCalmed" @keypress="validarStock" />
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <br><br>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
            <vs-button @click="guardarnuevo()" type="relief">Guardar</vs-button>&emsp;
            <vs-button @click="getCancelar()" color="danger" type="relief">Cancelar</vs-button>
        </vs-col>
    </vs-popup>
    <!-- SECCION EDITAR -->
    <!-- <vs-popup class="editar" :title="`Edición producto: ${tabProducto.pro_codigo}`" :active.sync="popupActivoEditar"> -->
    <vs-popup class="editar" :title="`Edición producto`" :active.sync="popupActivoEditar">
        <vs-row>
            <!-- {{ tabProducto }} -->
            <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" style="text-align: center;">
                <b>Información Producto</b>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
              <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                <vs-col vs-justify="center" vs-align="center" vs-w="11">
                    <font style="font-size: 11.5px">&nbsp;Producto padre</font><br>
                    <v-select :options="arrayTextosSinCombos" :reduce="arrayTextosSinCombos => arrayTextosSinCombos.pro_codigo" label="pro_codigo_nombre" class="w-full h-100" :class="{ 'input-error': errorPadreEditar }" placeholder="--Seleccione--" v-model="tabProducto.id_pro_codigo_padre" />
                    <span v-if="errorPadreEditar" style="color: red; font-size: 11.5px;">Seleccione un producto padre</span>
                    <small class="text-danger">No seleccionar si es un producto padre como manantial lengua 2 (solo si es folleto, cuaderno, guia)</small>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="11">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <font style="font-size: 11.5px">&nbsp;Grupo</font><br>
                        <v-select :options="Grupos" :reduce="Grupos => Grupos.gru_pro_codigo" label="gru_pro_nombre" class="w-full h-100" placeholder="--Seleccione--" v-model="tabProducto.gru_pro_codigo" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Codigo de producto" placeholder="Codigo" class="w-full" icon="mode_edit" v-model="tabProducto.pro_codigo" readonly />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
              <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                <vs-col vs-justify="center" vs-align="center" vs-w="10">
                    <font style="font-size: 11.5px">&nbsp;Grupo para v3</font><br>
                    <v-select :options="Grupos" :reduce="Grupos => Grupos.gru_pro_codigo" label="gru_pro_nombre" class="w-full h-100" :class="{ 'input-error': errorGrupoV3Editar }" placeholder="--Seleccione--" v-model="tabProducto.grupo_codigo_para_v3" @input="handleSelectInputEditar" />
                    <span v-if="errorGrupoV3Editar" style="color: red; font-size: 11.5px;">Seleccione un grupo para v3</span>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col v-if="tabProducto.gru_pro_codigo === 1 || tabProducto.gru_pro_codigo === 3 || tabProducto.gru_pro_codigo === 6" vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <font style="font-size: 11.5px">&nbsp;Serie</font><br>
                        <v-select :options="series" :reduce="series => series.id_serie" label="nombre_serie" placeholder="--Seleccione--" class="w-full" v-model="tabProducto.id_serie" />
                        <span v-if="!tabProducto.id_serie" style="color: red; font-size: 11.5px;">Este campo es obligatorio</span>
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Nombre " placeholder="Nombre" class="w-full" icon="mode_edit" v-model="tabProducto.pro_nombre" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Descripción " placeholder="Descripción" class="w-full" icon="mode_edit" v-model="tabProducto.pro_descripcion" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <!-- <vs-input label="Iva *" type="number" placeholder="Iva" class="w-full" icon="mode_edit" v-model="tabProducto.proIva" /> -->
                        <font style="font-size: 11.5px">&nbsp;IVA *</font><br>
                        <v-select :options="options1" :reduce="options1 => options1.value" label="text" class="w-full h-100" placeholder="--Seleccione--" v-model="tabProducto.pro_iva" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Valor " type="number" placeholder="Valor" class="w-full" icon="mode_edit" v-model="tabProducto.pro_valor" @keypress="validarValor" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <font style="font-size: 11.5px; display: inline-flex;">&nbsp;Descuento * &emsp; Formato: 0.00</font><br>
                        <vs-input type="number" id="pro-descuento-input" placeholder="Descuento" class="w-full" icon="mode_edit" v-model="tabProducto.pro_descuento" @keypress="validarDescuento" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Costo " type="number" placeholder="Costo" class="w-full" icon="mode_edit" v-model="tabProducto.pro_costo" @keypress="validarCosto" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                        <!-- {{tabusuario.pv_tipo_usuario}}  //Para ver que propiedad quiero guardar -->
                        <vs-input label="Peso " type="number" placeholder="Peso" class="w-full" icon="mode_edit" v-model="tabProducto.pro_peso" @keypress="validarPeso" />
                    </vs-col>
                </vs-row>
            </vs-col>
            <!-- <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" style="text-align: center; margin-top: 10px;"><b>Bodega Prolipa</b></vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                                <vs-input label="Stock Facturas" type="number" placeholder="Stock Facturas" class="w-full" icon="mode_edit" v-model="tabProducto.pro_stock" @keypress="validarStock" />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                                <vs-input label="Stock Notas" type="number" placeholder="Stock Notas" class="w-full" icon="mode_edit" v-model="tabProducto.pro_deposito" @keypress="validarStock" />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" style="text-align: center; margin-top: 10px;"><b>Bodega Calmed</b></vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                                <vs-input label="Stock Facturas" type="number" placeholder="Stock Facturas" class="w-full" icon="mode_edit" v-model="tabProducto.pro_stockCalmed" @keypress="validarStock" />
                            </vs-col>
                        </vs-row>
                    </vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="6">
                        <vs-row vs-type="flex" vs-justify="center" vs-w="12">
                            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
                                <vs-input label="Stock Notas" type="number" placeholder="Stock Notas" class="w-full" icon="mode_edit" v-model="tabProducto.pro_depositoCalmed" @keypress="validarStock" />
                            </vs-col>
                        </vs-row>
                    </vs-col> -->
            <vs-col vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" style="text-align: center; margin-top: 10px;"><b>El stock de los productos se debe actualizar en la sección de<br> "Edición Stock Masiva"</b></vs-col>
        </vs-row>
        <br><br>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" class="mt-2">
            <vs-button @click="editar()" type="relief">Editar</vs-button>&emsp;
            <vs-button @click="getCancelar()" color="danger" type="relief">Cancelar</vs-button>
        </vs-col>
    </vs-popup>
    <vs-popup class="eliminar" :title="`¿Confirma que desea eliminar el registro: ${pro_codigo} - ${pro_nombre}?`" :active.sync="popupActivoEliminar">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" class="mt-2"></vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" class="mt-2">
            <vs-button @click="getEliminar()" type="relief">Aceptar</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" class="mt-2">
            <vs-button @click="getCancelar()" color="danger" type="relief">Cancelar</vs-button>
        </vs-col>
    </vs-popup>
    <vs-popup class="desactivar" :title="`¿Confirma que desea cambiar el estado del producto: ${pro_codigo}?`" :active.sync="popupActivoDesactivar">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" class="mt-2"></vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" class="mt-2">
            <vs-button @click="desactivar_activar_producto()" type="relief">Aceptar</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" class="mt-2">
            <vs-button @click="getCancelar()" color="danger" type="relief">Cancelar</vs-button>
        </vs-col>
    </vs-popup>
    <!-- SECCION INFORMACIÓN -->
    <vs-popup class="informacionformhijo" @close="getConfiguracion()" title="Información" :active.sync="popupInformacionProducto">
        <Informacion_Producto v-if="popupInformacionProducto" :arrayConfiguration="arrayConfiguration" :popupInformacionProducto="popupInformacionProducto" @change="changeHandleInformacionProducto" />
    </vs-popup>
    <!-- SECCION EDICION MASIVA STOCK -->
    <vs-popup class="informacionformhijo" fullscreen @close="getConfiguracion()" title="Edición Masiva de Stock" :active.sync="popupEdicionMasivaStock">
        <EditMasivaPorducto_Producto v-if="popupEdicionMasivaStock" :arrayConfiguration="arrayConfiguration" :popupEdicionMasivaStock="popupEdicionMasivaStock" @change="changeHandleEdicionMasivaStock" />
    </vs-popup>
    <!-- SECCION REPORTE PRODUCTOS -->
    <vs-popup class="informacionformhijo" fullscreen @close="getConfiguracion()" title="Reportes de Productos" :active.sync="popupReporteProductos">
        <ReporteProductosGeneral v-if="popupReporteProductos" @change="changeHandleReporteProductos" />
    </vs-popup>
    <!-- SECCION HISTORICO EDICION MASIVA STOCK -->
    <vs-popup class="informacionformhijo" fullscreen @close="getConfiguracion()" title="Histórico Stock" :active.sync="popupHistoricoEdicionMasivaStock">
        <EditMasivaPorducto_ProductoHistorico v-if="popupHistoricoEdicionMasivaStock" :arrayConfiguration="arrayConfiguration" @change="changeHandleHistoricoEdicionMasivaStock" />
    </vs-popup>
    <!-- SECCION SINCRONIZAR PERSEO -->
    <vs-popup class="sincronizarPerseo" title="🔄 Vincular / Sincronizar Perseo" :active.sync="popupSincronizarPerseo">
        <div style="padding: 10px;">
            <vs-tabs>
                <!-- TAB 1: VINCULAR IDS -->
                <vs-tab label="🔗 Vincular IDs">
                    <div style="padding: 15px 0;">
                        <p style="margin-bottom: 10px; font-size: 13px; color: #555;">
                            <b>Vincular IDs:</b> Busca productos en Perseo por <b>código</b> y asigna el <code>productosid</code> al campo <code>id_perseo_*</code> local.
                            <br>Solo actualiza productos que <b>aún no tienen</b> ID de Perseo asignado (NULL o 0).
                        </p>
                        <vs-row vs-justify="center" style="gap: 8px;">
                            <vs-col vs-w="5" vs-sm="12" style="margin-bottom: 8px;">
                                <vs-button :disabled="sincronizandoPerseo" color="rgb(100, 59, 202)" type="border" class="w-full" @click="sincronizarPerseo(1, 'ids')">
                                    🔗 Emp 1 - Prolipa
                                </vs-button>
                            </vs-col>
                            <vs-col vs-w="5" vs-sm="12" style="margin-bottom: 8px;">
                                <vs-button :disabled="sincronizandoPerseo" color="rgb(31, 116, 255)" type="border" class="w-full" @click="sincronizarPerseo(3, 'ids')">
                                    🔗 Emp 3 - Calmed
                                </vs-button>
                            </vs-col>
                            <vs-col vs-w="5" vs-sm="12" style="margin-bottom: 8px;">
                                <vs-button :disabled="sincronizandoPerseo" color="rgb(234, 84, 85)" type="border" class="w-full" @click="sincronizarPerseo(4, 'ids')">
                                    🔗 Emp 4 - Calmed 2026
                                </vs-button>
                            </vs-col>
                            <vs-col vs-w="5" vs-sm="12" style="margin-bottom: 8px;">
                                <vs-button :disabled="sincronizandoPerseo" color="rgb(255, 159, 67)" type="border" class="w-full" @click="sincronizarPerseo(5, 'ids')">
                                    🔗 Emp 5 - Prolipa 2026
                                </vs-button>
                            </vs-col>
                        </vs-row>
                    </div>
                </vs-tab>
                <!-- TAB 2: SINCRONIZAR STOCK -->
                <vs-tab label="📦 Sincronizar Stock">
                    <div style="padding: 15px 0;">
                        <p style="margin-bottom: 10px; font-size: 13px; color: #555;">
                            <b>Sincronizar Stock:</b> Actualiza <code>pro_reservar</code> y <code>pro_stockCalmed</code> con el valor de <code>existenciastotales</code> de Perseo.
                            <br>Solo actualiza productos que <b>ya tienen</b> ID de Perseo vinculado y coincidan ambos códigos.
                        </p>
                        <vs-row vs-justify="center" style="gap: 8px;">
                            <vs-col vs-w="5" vs-sm="12" style="margin-bottom: 8px;">
                                <vs-button :disabled="sincronizandoPerseo" color="rgb(100, 59, 202)" type="relief" class="w-full" @click="sincronizarPerseo(1, 'stock')">
                                    📦 Emp 1 - Prolipa
                                </vs-button>
                            </vs-col>
                            <vs-col vs-w="5" vs-sm="12" style="margin-bottom: 8px;">
                                <vs-button :disabled="sincronizandoPerseo" color="rgb(31, 116, 255)" type="relief" class="w-full" @click="sincronizarPerseo(3, 'stock')">
                                    📦 Emp 3 - Calmed
                                </vs-button>
                            </vs-col>
                            <vs-col vs-w="5" vs-sm="12" style="margin-bottom: 8px;">
                                <vs-button :disabled="sincronizandoPerseo" color="rgb(234, 84, 85)" type="relief" class="w-full" @click="sincronizarPerseo(4, 'stock')">
                                    📦 Emp 4 - Calmed 2026
                                </vs-button>
                            </vs-col>
                            <vs-col vs-w="5" vs-sm="12" style="margin-bottom: 8px;">
                                <vs-button :disabled="sincronizandoPerseo" color="rgb(255, 159, 67)" type="relief" class="w-full" @click="sincronizarPerseo(5, 'stock')">
                                    📦 Emp 5 - Prolipa 2026
                                </vs-button>
                            </vs-col>
                        </vs-row>
                    </div>
                </vs-tab>
            </vs-tabs>
            <!-- Indicador de carga -->
            <div v-if="sincronizandoPerseo" style="text-align: center; margin-top: 20px;">
                <p style="font-size: 14px; color: #7367F0;"><b>⏳ Procesando... Por favor espere, esto puede tardar unos minutos.</b></p>
            </div>
            <!-- Resultados de la sincronización -->
            <div v-if="resultadoSincronizacion" style="margin-top: 20px; padding: 15px; border-radius: 8px;" :style="{ backgroundColor: resultadoSincronizacion.status === 1 ? '#f0fdf4' : '#fef2f2', border: resultadoSincronizacion.status === 1 ? '1px solid #86efac' : '1px solid #fca5a5' }">
                <h4 style="margin-bottom: 10px;" :style="{ color: resultadoSincronizacion.status === 1 ? '#166534' : '#991b1b' }">
                    {{ resultadoSincronizacion.status === 1 ? '✅ Proceso Exitoso' : '❌ Error' }}
                </h4>
                <div v-if="resultadoSincronizacion.status === 1">
                    <p><b>Tipo:</b> {{ resultadoSincronizacion.tipo === 'ids' ? '🔗 Vincular IDs' : '📦 Sincronizar Stock' }}</p>
                    <p><b>Empresa:</b> {{ resultadoSincronizacion.empresa }}</p>
                    <p><b>Productos recibidos de Perseo:</b> {{ resultadoSincronizacion.productos_recibidos }}</p>
                    <p style="color: #166534;"><b>Productos actualizados:</b> {{ resultadoSincronizacion.productos_actualizados }}</p>
                    <p style="color: #92400e;"><b>Productos ignorados:</b> {{ resultadoSincronizacion.productos_ignorados }}</p>
                    <p v-if="resultadoSincronizacion.errores && resultadoSincronizacion.errores.length > 0" style="color: #991b1b;"><b>Errores:</b> {{ resultadoSincronizacion.errores.length }}</p>
                    <br>
                    <p style="font-weight: bold; color: #166534;">{{ resultadoSincronizacion.mensaje }}</p>
                </div>
                <div v-else>
                    <p style="color: #991b1b;">{{ resultadoSincronizacion.mensaje }}</p>
                </div>
                <!-- Detalle de errores si los hay -->
                <div v-if="resultadoSincronizacion.errores && resultadoSincronizacion.errores.length > 0" style="margin-top: 10px;">
                    <p style="color: #991b1b; font-weight: bold;">Detalle de errores:</p>
                    <ul style="max-height: 150px; overflow-y: auto;">
                        <li v-for="(err, idx) in resultadoSincronizacion.errores" :key="idx" style="font-size: 12px; color: #991b1b;">
                            {{ err.pro_codigo }}: {{ err.error }}
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Botón cerrar -->
            <vs-row vs-justify="center" style="margin-top: 20px;">
                <vs-button @click="popupSincronizarPerseo = false; resultadoSincronizacion = null" color="danger" type="relief">Cerrar</vs-button>
            </vs-row>
        </div>
    </vs-popup>
</vx-card>
</template>

<script>
import {
    mapState
} from 'vuex';
import Vue from 'vue'
import axios from 'axios'
import vSelect from 'vue-select';
import Codigosmix from "@/mixins/Codigosmix";
const Informacion_Producto = () => import("@/views/facturacion/10_10_1_4/orden_pedido/producto_crud_informacion.vue");
const EditMasivaPorducto_Producto = () => import("@/views/facturacion/10_10_1_4/orden_pedido/ediciones_stock_masiva/producto_edicionstockmasiva.vue");
const EditMasivaPorducto_ProductoHistorico = () => import("@/views/facturacion/10_10_1_4/orden_pedido/ediciones_stock_masiva/producto_edicionstockmasivahistorico.vue");
const ReporteProductosGeneral = () => import("@/views/facturacion/10_10_1_4/orden_pedido/components/screen_reportes_producto_crud.vue");
export default {
    mixins: [Codigosmix],
    data() {
        return {
            options1: [{
                    text: '--Seleccione--',
                    value: null
                },
                {
                    text: 'Si',
                    value: 1
                },
                {
                    text: 'No',
                    value: 0
                },
            ],
            Productos: [],
            popupActivoGuardar: false,
            popupActivoEditar: false,
            popupActivoDesactivar: false,
            popupActivoEliminar: false,
            tabProducto: {
                pro_codigo: '',
                gru_pro_codigo: '',
                pro_nombre: '',
                pro_descripcion: '',
                pro_iva: '',
                pro_valor: '',
                pro_descuento: '',
                pro_stock: '',
                pro_stockCalmed: '',
                pro_deposito: '',
                pro_depositoCalmed: '',
                pro_costo: '',
                pro_peso: '',
                pro_estado: '',
                id_serie: '',
                idlibro: '',
                year: '',
                sumainicial: '',
                valornuevosumado: '',
                calculoaplicara_pro_reservar: '',
                pro_reservar_anterior: '',
                id_pro_codigo_padre: '',
                grupo_codigo_para_v3: '',
            },
            errorPadreGuardar: false,
            errorPadreEditar: false,
            errorGrupoV3Guardar: false,
            errorGrupoV3Editar: false,
            series: [],
            libros: [],
            pro_codigo: null,
            pro_nombre: null,
            mostrarSeleccionSerie: false,
            idlibro: null,
            id_serie: null,
            pro_codigo_antiguo: 0,
            id_serie_antiguo: null,
            Grupos: [],
            Producto_sinfiltro: [],
            Producto_inactivos: [],
            busquedaxcodigo: "",
            valorBusqueda: "0",
            checkBox_mostrarinactivos: false,
            busqueda: '',
            numeros: 0,
            arrayConfiguration: [],
            popupInformacionProducto: false,
            popupEdicionMasivaStock: false,
            popupReporteProductos: false,
            popupHistoricoEdicionMasivaStock: false,
            //showAgregarNuevo: false,
            arrayTextosSinCombos: [],
            // Sincronizar Perseo
            popupSincronizarPerseo: false,
            sincronizandoPerseo: false,
            resultadoSincronizacion: null,
        }
    },
    watch: {
        valorBusqueda(newValue) {
            if (newValue === '0') {
                this.Productos = [];
            } else if (newValue === '1') {
                this.Productos = [];
            }
            if (newValue === '2') {
                this.valorBusqueda = '2';
                this.busqueda = 'codigopro';
            }
        },
        'tabProducto.pro_codigo': function (newVal, oldVal) {
            const numeros = newVal.replace(/\D/g, '');
            this.tabProducto.year = numeros;
            this.tabProducto.codigo_liquidacion = newVal;
        },
        'tabProducto.gru_pro_codigo': function (newValue, oldValue) {
            // Actualiza la visibilidad del bloque de selección de serie basado en la condición
            this.mostrarSeleccionSerie = (newValue === 1 || newValue === 3 || newValue === 6);
        }
    },
    components: {
        'v-select': vSelect,
        Informacion_Producto,
        EditMasivaPorducto_Producto,
        EditMasivaPorducto_ProductoHistorico,
        ReporteProductosGeneral,
    },
    computed: {
        ...mapState(['userRoot', 'groupFacturador', 'AdminBodega', 'groupBodega', 'AsisGerencia', 'userFacturador', 'userAdminFacturador']),
    },
    mounted() {
      this.getGrupoProducto();
      this.getProducto();
      this.getLibros()
      this.listaSeries();
      this.getConfiguracion();
      this.f_getTextosSinCombos();
    },
    methods: {
        f_getTextosSinCombos(){
          let me = this;
          this.$http.get(this.$server_url + 'GetProductoXGrupo?grupo_codigo=1&sinCombos=1')
            .then(function (res) {
              me.arrayTextosSinCombos = res.data;
            })
            .catch(function (error) {
              console.log(error + ' error');
            })
        },
        getInformacionProducto() {
            this.popupInformacionProducto = true;
        },
        getEdicionMasivaStock() {
            this.popupEdicionMasivaStock = true;
        },
        getReporteProductos() {
            this.popupReporteProductos = true;
        },
        HistoricoEdicionMasivaStock() {
            this.popupHistoricoEdicionMasivaStock = true;
        },
        abrirModalSincronizarPerseo() {
            this.popupSincronizarPerseo = true;
            this.resultadoSincronizacion = null;
            this.sincronizandoPerseo = false;
        },
        sincronizarPerseo(idEmpresa, tipo) {
            let me = this;
            me.sincronizandoPerseo = true;
            me.resultadoSincronizacion = null;

            me.$http.post(me.$server_url + 'api/perseo/productos/sincronizar_existencias_perseo', {
                id_empresa: idEmpresa,
                tipo: tipo
            })
            .then(function (res) {
                me.sincronizandoPerseo = false;
                me.resultadoSincronizacion = res.data;

                if (res.data.status === 1) {
                    me.$vs.notify({
                        text: res.data.mensaje,
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    });
                } else {
                    me.$vs.notify({
                        text: res.data.mensaje || 'Error en el proceso',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-x'
                    });
                }
            })
            .catch(function (error) {
                me.sincronizandoPerseo = false;
                let mensajeError = 'Error de conexión con el servidor';
                if (error.response && error.response.data) {
                    mensajeError = error.response.data.mensaje || error.response.data.message || mensajeError;
                }
                me.resultadoSincronizacion = {
                    status: 0,
                    mensaje: mensajeError
                };
                me.$vs.notify({
                    text: mensajeError,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-x'
                });
                console.error('Error sincronizando Perseo:', error);
            });
        },
        changeHandleInformacionProducto(e) {
            let me = this;
            // console.log("realizarcchangeinicio")
            // console.log(e.verificacionemiteliminar); // Debería imprimir 1
            if (e.verificarinfoactualizar == 1) {
                console.log("Emit recibido por aceptar.");
                me.popupInformacionProducto = false;
                this.getConfiguracion();
            } else if (e.verificarinfoactualizar == 2) {
                console.log("Emit recibido por cerrar.");
                this.getConfiguracion();
                me.popupInformacionProducto = false;
            } else {
                console.log("Emit no recibido");
            }
        },
        changeHandleEdicionMasivaStock(e) {
            let me = this;
            // console.log("realizarcchangeinicio")
            // console.log(e.verificacionemiteliminar); // Debería imprimir 1
            if (e.verificaredicionmasivaactualizar == 1) {
                console.log("Emit recibido por guardado.");
                me.popupEdicionMasivaStock = false;
                this.getConfiguracion();
            } else if (e.verificaredicionmasivaactualizar == 2) {
                console.log("Emit recibido por cancelar.");
                this.getConfiguracion();
                me.popupEdicionMasivaStock = false;
            } else {
                console.log("Emit no recibido");
            }
        },
        changeHandleReporteProductos(e) {
            let me = this;
            // console.log("realizarcchangeinicio")
            // console.log(e.verificacionemiteliminar); // Debería imprimir 1
            if (e.verificarhistoricoedicionmasivaactualizar == 1) {
                console.log("Emit recibido por guardado.");
                me.popupHistoricoEdicionMasivaStock = false;
                this.getConfiguracion();
            } else if (e.verificarhistoricoedicionmasivaactualizar == 2) {
                console.log("Emit recibido por cancelar.");
                this.getConfiguracion();
                me.popupHistoricoEdicionMasivaStock = false;
            } else {
                console.log("Emit no recibido");
            }
        },
        changeHandleHistoricoEdicionMasivaStock(e) {
            let me = this;
            // console.log("realizarcchangeinicio")
            // console.log(e.verificacionemiteliminar); // Debería imprimir 1
            if (e.verificarhistoricoedicionmasivaactualizar == 1) {
                console.log("Emit recibido por guardado.");
                me.popupHistoricoEdicionMasivaStock = false;
                this.getConfiguracion();
            } else if (e.verificarhistoricoedicionmasivaactualizar == 2) {
                console.log("Emit recibido por cancelar.");
                this.getConfiguracion();
                me.popupHistoricoEdicionMasivaStock = false;
            } else {
                console.log("Emit no recibido");
            }
        },
        getStockClass(value, id) {
            const config = this.arrayConfiguration.find(config => config.id === id);
            if (!config) return '';

            if (value < 1) {
                return 'text-red';
            } else if (value < config.minimo) {
                return 'text-orange';
            } else {
                return 'text-green'; // Color verde si es mayor o igual al mínimo
            }
        },
        getConfiguracion() {
            let me = this;
            this.$http.get(this.$server_url + 'inventario/configuracion')
                .then(function (res) {
                    me.arrayConfiguration = res.data
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
        },
        handleSelectInputGuardar(selectedItem) {
            // Resetear el error cuando se selecciona un valor
            if (selectedItem !== null && selectedItem !== '') {
                this.errorGrupoV3Guardar = false;
            }
            if (selectedItem === 1) {
                // Llama a tu función aquí
                this.funcionPrueba();
            }
        },
        handleSelectInputEditar(selectedItem) {
            // Resetear el error cuando se selecciona un valor
            if (selectedItem !== null && selectedItem !== '') {
                this.errorGrupoV3Editar = false;
            }
            if (selectedItem === 1) {
                // Llama a tu función aquí
                this.funcionPrueba();
            }
        },
        funcionPrueba() {
            console.log('prueba')
        },
        convertirAMayusculas() {
            const numerosString = this.tabProducto.pro_codigo.replace(/\D/g, '');
            this.numeros = numerosString ? parseInt(numerosString) : 0; // Asignar el valor a tabProducto.pro_codigo
            // Extraer los números y almacenarlos en la variable 'numeros'

            // Convertir el texto a mayúsculas
            this.tabProducto.pro_codigo = this.tabProducto.pro_codigo.toUpperCase();
            this.pro_codigo_antiguo = this.tabProducto.pro_codigo;
            this.id_serie_antiguo = this.tabProducto.id_serie;
        },
        ObtenerCodigo() {
            const codigoActual = this.tabProducto.pro_codigo;
            this.pro_codigo_antiguo = codigoActual; // Asignar el valor a tabProducto.pro_codigo
        },
        isGrupoProhibido(gru_pro_codigo) {
            // Aquí puedes colocar la lógica para verificar si el grupo es prohibido
            if (gru_pro_codigo === 1) {
                // Muestra la notificación de error
                this.$vs.notify({
                    text: 'No puedes guardar con este grupo',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-x'
                });
                return true; // Devuelve true si el grupo es prohibido
            } else {
                return false; // Devuelve false si el grupo no es prohibido
            }
        },
        validarDescuento() {
            let descuento = this.tabProducto.pro_descuento;
            // Reemplazar comas por puntos solo si hay comas en la cadena
            if (descuento.includes(',')) {
                descuento = descuento.replace(',', '.');
                this.tabProducto.pro_descuento = descuento;
            }
            // Validar el formato del número
            if (!/^\d{0,14}(\.\d{0,2})?$/.test(descuento)) {
                this.tabProducto.pro_descuento = '';
                console.log("reset");
            }
        },
        validarValor() {
            const valor = this.tabProducto.proValor;
            if (/^\d/.test(valor)) { // si comienza con un dígito
                if (!/^\d{0,18}(\.\d{1,5})?$/.test(valor)) {
                    this.tabProducto.proValor = '';
                }
            } else if (/^[,.e]/.test(valor)) { // si comienza con una coma o un punto
                if (!/^([,.]\d{1,5})?$/.test(valor)) {
                    this.tabProducto.proValor = '';
                }
            } else { // si comienza con cualquier otro caracter
                this.tabProducto.proValor = '';
            }
        },
        validarStock() {
            let stock = this.tabProducto.proStock;
            if (!/^\d+$/.test(stock) || isNaN(stock)) {
                this.tabProducto.proStock = '';
            }
        },
        validarCosto() {
            const costo = this.tabProducto.proCosto;
            if (/^\d/.test(costo)) { // si comienza con un dígito
                if (!/^\d{0,18}(\.\d{1,5})?$/.test(costo)) {
                    this.tabProducto.proCosto = '';
                }
            } else if (/^[,.e]/.test(costo)) { // si comienza con una coma o un punto
                if (!/^([,.]\d{1,5})?$/.test(costo)) {
                    this.tabProducto.proCosto = '';
                }
            } else { // si comienza con cualquier otro caracter
                this.tabProducto.proCosto = '';
            }
        },
        validarPeso() {
            const peso = this.tabProducto.proPeso;
            if (/^\d/.test(peso)) { // si comienza con un dígito
                if (!/^\d{0,15}(\.\d{1,5})?$/.test(peso)) {
                    this.tabProducto.proPeso = '';
                }
            } else if (/^[,.e]/.test(peso)) { // si comienza con una coma o un punto
                if (!/^([,.]\d{1,5})?$/.test(peso)) {
                    this.tabProducto.proPeso = '';
                }
            } else { // si comienza con cualquier otro caracter
                this.tabProducto.proPeso = '';
            }
        },
        handleRadioInput(opcion) {
            // Vacía el array Productos cuando se selecciona la opción 'nombres'
            if (opcion === 'nombres') {
                this.Productos = [];
            } else if (opcion === 'codigopro') {
                this.Productos = [];
            }
        },
        getGrupoProducto() {
            let me = this;
            this.$http.get(this.$server_url + 'GetGrupoProducto_todo')
                //axios.get(this.$apifacturacion_url + 'f_Producto')
                .then(res => {
                    //let resultado = res.data.productos.filter(p => p.proCodigo !== 0);
                    //this.Productos = resultado;
                    this.Grupos = res.data;
                    // console.log(this.Productos);
                    // console.log(this.Grupos);
                })
                .catch(err => {
                    console.log(err)
                })
        },
        getLibros() {
            let me = this;
            me.$vs.loading();
            this.$http.get(this.$server_url + 'getLibroP')
                .then(function (res) {
                    me.libros = res.data
                    me.$vs.loading.close()
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close()

                })
        },
        getProducto() {
            let me = this;
            this.$http.get(this.$server_url + 'GetProducto')
                //axios.get(this.$apifacturacion_url + 'f_Producto')
                .then(res => {
                    //let resultado = res.data.productos.filter(p => p.proCodigo !== 0);
                    //this.Productos = resultado;
                    this.Producto_sinfiltro = res.data;
                    // console.log(this.Productos);
                    // console.log(this.Grupos);
                })
                .catch(err => {
                    console.log(err)
                })
        },
        getProductos_inactivos() {
            let me = this;
            this.busquedaxcodigo = '';
            this.getConfiguracion();
            me.$vs.loading();
            this.$http.get(this.$server_url + 'GetProducto_Inactivo')
                .then(res => {
                    this.Productos = res.data;
                    if (me.Productos.length === 0) {
                        me.$vs.notify({
                            text: 'No hay productos inactivos',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x'
                        });
                        me.Productos = [];
                        me.$vs.loading.close();
                    } else {
                        me.$vs.loading.close();
                        if (res.data.message) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-user'
                            });
                        }

                        me.Productos.forEach(producto => {
                            let suma = (producto.pro_stock || 0) +
                                (producto.pro_stockCalmed || 0) +
                                (producto.pro_deposito || 0) +
                                (producto.pro_depositoCalmed || 0);
                            // Campos calculados
                            producto.sumainicial = suma;
                            producto.valornuevosumado = suma; // Inicializado como 0, actualiza según sea necesario
                            producto.calculoaplicara_pro_reservar = 0; // Inicializado como 0
                            producto.pro_reservar_anterior = producto.pro_reservar; // Guardar el valor anterior
                            // Agregar clases de color a las propiedades de cada producto
                            producto.pro_reservarClass = me.getStockClass(producto.pro_reservar, 1);
                            producto.pro_stockClass = me.getStockClass(producto.pro_stock, 2);
                            producto.pro_depositoClass = me.getStockClass(producto.pro_deposito, 4);
                            producto.pro_stockCalmedClass = me.getStockClass(producto.pro_stockCalmed, 3);
                            producto.pro_depositoCalmedClass = me.getStockClass(producto.pro_depositoCalmed, 5);
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    me.$vs.loading.close();
                });
        },
        getProductos_stockminimo() {
            let me = this;
            this.busquedaxcodigo = '';
            this.getConfiguracion();
            me.$vs.loading();
            this.$http.get(this.$server_url + 'GetProducto_StockMenor')
                .then(res => {
                    this.Productos = res.data;
                    if (me.Productos.length === 0) {
                        me.$vs.notify({
                            text: 'No hay productos en stock mínimo',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x'
                        });
                        me.Productos = [];
                        me.$vs.loading.close();
                    } else {
                        me.$vs.loading.close();
                        if (res.data.message) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-user'
                            });
                        }

                        me.Productos.forEach(producto => {
                            let suma = (producto.pro_stock || 0) +
                                (producto.pro_stockCalmed || 0) +
                                (producto.pro_deposito || 0) +
                                (producto.pro_depositoCalmed || 0);
                            // Campos calculados
                            producto.sumainicial = suma;
                            producto.valornuevosumado = suma; // Inicializado como 0, actualiza según sea necesario
                            producto.calculoaplicara_pro_reservar = 0; // Inicializado como 0
                            producto.pro_reservar_anterior = producto.pro_reservar; // Guardar el valor anterior
                            // Agregar clases de color a las propiedades de cada producto
                            producto.pro_reservarClass = me.getStockClass(producto.pro_reservar, 1);
                            producto.pro_stockClass = me.getStockClass(producto.pro_stock, 2);
                            producto.pro_depositoClass = me.getStockClass(producto.pro_deposito, 4);
                            producto.pro_stockCalmedClass = me.getStockClass(producto.pro_stockCalmed, 3);
                            producto.pro_depositoCalmedClass = me.getStockClass(producto.pro_depositoCalmed, 5);
                        });
                        // console.log(me.Productos, "productoencotnrado");
                    }
                })
                .catch(err => {
                    console.log(err);
                    me.$vs.loading.close();
                });
        },
        getProductoParametro() {
            let me = this;
            this.checkBox_mostrarinactivos = false;
            this.tabProducto.gru_pro_codigo;
            if (this.userAdminFacturador == true || this.userFacturador == true) {

            }
            this.getConfiguracion();

            if (me.busquedaxcodigo.length < 2) {
                me.$vs.notify({
                    text: 'Mínimo 2 caracteres de búsqueda',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-check'
                });
                return false;
            }

            me.$vs.loading();
            this.$http.get(this.$server_url + 'GetProductoActivosxFiltro?busqueda=' + me.busqueda + '&razonbusqueda=' + me.busquedaxcodigo)
                .then(function (res) {
                    me.Productos = res.data;
                    if (me.Productos.length === 0) {
                        me.$vs.notify({
                            text: 'No hay productos para esta búsqueda',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x'
                        });
                        me.Productos = [];
                        me.$vs.loading.close();
                    } else {
                        me.$vs.loading.close();
                        if (res.data.message) {
                            me.$vs.notify({
                                text: res.data.message,
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-user'
                            });
                        }
                        // Filtrar si el usuario es facturador o admin facturador
                        // Filtrar si el usuario es facturador o admin facturador
                        if (me.userFacturador || me.userAdminFacturador) {
                            me.Productos = me.Productos.filter(p => p.gru_pro_codigo == 1 || p.gru_pro_codigo == 2)
                            //test
                            // Verificar si después del filtro hay productos
                            if (me.Productos.length === 0) {
                                me.$vs.notify({
                                    text: 'No hay productos para esta búsqueda',
                                    color: 'danger',
                                    iconPack: 'feather',
                                    icon: 'icon-x'
                                });
                                return; // Salimos para evitar ejecutar el forEach
                            }
                        }
                        me.Productos.forEach(producto => {
                            let suma = (producto.pro_stock || 0) +
                                (producto.pro_stockCalmed || 0) +
                                (producto.pro_deposito || 0) +
                                (producto.pro_depositoCalmed || 0);
                            // Campos calculados
                            producto.sumainicial = suma;
                            producto.valornuevosumado = suma; // Inicializado como 0, actualiza según sea necesario
                            producto.calculoaplicara_pro_reservar = 0; // Inicializado como 0
                            producto.pro_reservar_anterior = producto.pro_reservar; // Guardar el valor anterior
                            // Aplicar las clases de color a las propiedades existentes
                            producto.pro_reservarClass = me.getStockClass(producto.pro_reservar, 1);
                            producto.pro_stockClass = me.getStockClass(producto.pro_stock, 2);
                            producto.pro_depositoClass = me.getStockClass(producto.pro_deposito, 4);
                            producto.pro_stockCalmedClass = me.getStockClass(producto.pro_stockCalmed, 3);
                            producto.pro_depositoCalmedClass = me.getStockClass(producto.pro_depositoCalmed, 5);
                        });
                        // console.log(me.Productos,"tesssssssssssssssss");
                    }
                })
                .catch(function (error) {
                    if (error.response && error.response.status === 404) {
                        me.$vs.notify({
                            text: 'No hay productos para esta búsqueda',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x'
                        });
                        me.Productos = [];
                        me.$vs.loading.close();
                    } else {
                        console.log(error + ' error');
                        me.$vs.loading.close();
                    }
                });
        },
        //lista de series para usar en el select
        listaSeries() {
            let me = this
            me.$vs.loading()
            this.$http.get(this.$server_url + `GetSeriesL`).then(res => {
                    me.series = res.data;
                    me.$vs.loading.close();
                })
                .catch(function (error) {
                    console.log(error)
                    me.$vs.loading.close();
                })
        },
        validarCampoSerie() {
            // Verifica si tabProducto.gru_pro_codigo es 1, 3 o 6
            if (this.tabProducto.gru_pro_codigo === 1 || this.tabProducto.gru_pro_codigo === 3 || this.tabProducto.gru_pro_codigo === 6) {
                // Verifica si el campo de serie está vacío
                if (!this.tabProducto.id_serie) {
                    // El campo está vacío, devuelve false para indicar que la validación falló
                    return false;
                }
            }
            // Si no se cumple la condición, devuelve true automáticamente sin validar el campo de serie
            return true;
        },
        //SECCION GUARDAR NUEVO PRODUCTO
        getNuevo() {
            this.popupActivoGuardar = true
            this.tabProducto.pro_codigo = ''
            this.tabProducto.gru_pro_codigo = null
            this.tabProducto.pro_costo = null
            this.tabProducto.pro_descripcion = ''
            this.tabProducto.pro_descuento = ''
            this.tabProducto.pro_iva = null
            this.tabProducto.pro_nombre = ''
            this.tabProducto.pro_peso = ''
            this.tabProducto.pro_stock = ''
            this.tabProducto.pro_stockCalmed = ''
            this.tabProducto.pro_deposito = ''
            this.tabProducto.pro_depositoCalmed = ''
            this.tabProducto.pro_valor = ''
            this.tabProducto.id_serie = ''
            this.tabProducto.id_pro_codigo_padre = ''
            this.tabProducto.grupo_codigo_para_v3 = ''
            this.errorPadreGuardar = false
            this.errorGrupoV3Guardar = false
        },
        guardarnuevo() {
            let me = this;
            let resultado = me.Producto_sinfiltro.filter(v => v.pro_codigo == this.tabProducto.pro_codigo);
            let resultado2 = me.series.filter(v => v.codigo_liquidacion == this.tabProducto.pro_codigo);
            const usuariorespo = localStorage.getItem("usuario");
            const usuarioObjeto = JSON.parse(usuariorespo);
            const numeros = this.tabProducto.pro_codigo.replace(/\D/g, '');
            // VALIDAR STOCK Y DEPÓSITO
            let pro_reservar = 0;

            // Verificación y ajuste de pro_deposito
            if (this.tabProducto.pro_deposito === 0 || this.tabProducto.pro_deposito === '') {
                this.tabProducto.pro_deposito = 0;
            } else {
                this.tabProducto.pro_deposito = parseFloat(this.tabProducto.pro_deposito);
            }

            // Verificación y ajuste de pro_depositoCalmed
            if (this.tabProducto.pro_depositoCalmed === 0 || this.tabProducto.pro_depositoCalmed === '') {
                this.tabProducto.pro_depositoCalmed = 0;
            } else {
                this.tabProducto.pro_depositoCalmed = parseFloat(this.tabProducto.pro_depositoCalmed);
            }

            // Verificación y ajuste de pro_stock
            if (this.tabProducto.pro_stock === 0 || this.tabProducto.pro_stock === '') {
                this.tabProducto.pro_stock = 0;
            } else {
                this.tabProducto.pro_stock = parseFloat(this.tabProducto.pro_stock);
            }

            // Verificación y ajuste de pro_stockCalmed
            if (this.tabProducto.pro_stockCalmed === 0 || this.tabProducto.pro_stockCalmed === '') {
                this.tabProducto.pro_stockCalmed = 0;
            } else {
                this.tabProducto.pro_stockCalmed = parseFloat(this.tabProducto.pro_stockCalmed);
            }

            // Calcular pro_reservar como la suma de todas las variables
            pro_reservar = this.tabProducto.pro_stock +
                this.tabProducto.pro_stockCalmed +
                this.tabProducto.pro_deposito +
                this.tabProducto.pro_depositoCalmed;

            if (numeros == 0 || numeros == '') {
                this.tabProducto.year = 0
            } else {
                this.tabProducto.year = numeros;
            }

            if (resultado.length > 0 || resultado2.length > 0) {
                me.$vs.notify({
                    text: 'Ya existe un registro con ese código de producto',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            //VALIDACION DE CAMPOS NULOS Y VACIOS
            if (this.tabProducto.pro_codigo === '' || this.tabProducto.pro_codigo === null) {
                me.$vs.notify({
                    text: 'Escriba el código del Producto antes de guardar',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if (this.tabProducto.gru_pro_codigo === '' || this.tabProducto.gru_pro_codigo === null) {
                me.$vs.notify({
                    text: 'Seleccione el grupo del producto antes de guardar',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if (this.validarCampoSerie()) {
                console.log('El campo de serie está lleno. Puedes continuar con el guardado.');
            } else {
                me.$vs.notify({
                    text: 'El campo de serie está vacío. No puedes continuar con el guardado.',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if(this.tabProducto.gru_pro_codigo !=1){
              // validamos que tabProducto.id_pro_codigo_padre no este vacio
              if (this.tabProducto.id_pro_codigo_padre == '' || this.tabProducto.id_pro_codigo_padre === null || this.tabProducto.id_pro_codigo_padre == undefined) {
                  this.errorPadreGuardar = true;
                  this.$forceUpdate();
                  this.$nextTick(() => {
                    me.$vs.notify({
                        text: 'Seleccione el producto padre antes de guardar',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                  });
                  return;
              } else {
                  this.errorPadreGuardar = false;
              }
            }
            if(this.tabProducto.grupo_codigo_para_v3 == '' || this.tabProducto.grupo_codigo_para_v3 === null){
              this.errorGrupoV3Guardar = true;
              this.$forceUpdate();
              this.$nextTick(() => {
                me.$vs.notify({
                    text: 'Ingrese el grupo para v3 antes de guardar',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
              });
              return;
            } else {
              this.errorGrupoV3Guardar = false;
            }
            let datos = {
                "pro_codigo": this.tabProducto.pro_codigo,
                "gru_pro_codigo": this.tabProducto.gru_pro_codigo,
                "pro_nombre": this.tabProducto.pro_nombre,
                "pro_descripcion": this.tabProducto.pro_descripcion,
                "pro_iva": this.tabProducto.pro_iva,
                "pro_valor": parseFloat(this.tabProducto.pro_valor),
                "pro_descuento": parseFloat(this.tabProducto.pro_descuento),
                "pro_reservar": parseFloat(pro_reservar),
                "pro_stock": parseFloat(this.tabProducto.pro_stock),
                "pro_deposito": parseFloat(this.tabProducto.pro_deposito),
                "pro_stockCalmed": parseFloat(this.tabProducto.pro_stockCalmed),
                "pro_depositoCalmed": parseFloat(this.tabProducto.pro_depositoCalmed),
                "pro_costo": parseFloat(this.tabProducto.pro_costo),
                "pro_peso": parseFloat(this.tabProducto.pro_peso),
                "nombrelibro": this.tabProducto.pro_nombre,
                "nombre_imprimir": this.tabProducto.pro_nombre,
                "descripcionlibro": this.tabProducto.pro_descripcion,
                "serie": 0,
                "weblibro": null,
                "pdfsinguia": null,
                "pdfconguia": null,
                "guiadidactica": null,
                "asignatura_idasignatura": null,
                "portada": "portada.png",
                "demo": null,
                "id_serie": this.tabProducto.id_serie,
                "codigo_liquidacion": this.tabProducto.pro_codigo,
                "year": parseInt(this.tabProducto.year),
                "version2": parseInt(this.tabProducto.year),
                "s_weblibro": null,
                "s_pdfsinguia": null,
                "s_pdfconguia": null,
                "s_guiadidactica": null,
                "s_portada": "portada.png",
                "c_weblibro": null,
                "c_pdfsinguia": null,
                "c_pdfconguia": null,
                "c_guiadidactica": null,
                "c_portada": "portada.png",
                "user_created": usuarioObjeto.idusuario,
                "id_pro_codigo_padre": this.tabProducto.id_pro_codigo_padre,
                "grupo_codigo_para_v3": this.tabProducto.grupo_codigo_para_v3
            }
            me.$vs.loading()
            //axios.post(this.$apifacturacion_url + 'f_Vendedor', datos)
            this.$http.post(this.$server_url + 'Registrar_modificar_producto', datos)
                // this.$http.post(this.$server_url+'guardarLibro', datos2)
                .then(res => {
                    me.$vs.loading.close()
                    // this.getProducto();
                    this.getProductoParametro();
                    me.$vs.notify({
                        text: res.data.message || 'Guardado con éxito',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    });
                    this.errorPadreGuardar = false;
                    this.errorPadreEditar = false;
                    this.errorGrupoV3Guardar = false;
                    this.errorGrupoV3Editar = false;
                    this.popupActivoEditar = false;
                    this.popupActivoDesactivar = false;
                    this.popupActivoGuardar = false;
                    this.popupActivoEliminar = false;
                })
                .catch(function () {
                    me.$vs.loading.close();
                    const errorMsg = err.response && err.response.data && err.response.data.message ?
                        err.response.data.message :
                        'Producto no se pudo guardar';
                    me.$vs.notify({
                        text: errorMsg,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-x'
                    });
                })
        },
        getEditar(tr) {
            this.popupActivoEditar = true
            this.tabProducto.pro_codigo = tr.pro_codigo
            this.pro_codigo_antiguo = tr.pro_codigo
            this.tabProducto.gru_pro_codigo = tr.gru_pro_codigo
            this.id_serie_antiguo = tr.gru_pro_codigo
            this.tabProducto.pro_nombre = tr.pro_nombre
            this.tabProducto.pro_descripcion = tr.pro_descripcion
            this.tabProducto.pro_iva = tr.pro_iva
            this.tabProducto.pro_valor = tr.pro_valor
            this.tabProducto.pro_descuento = tr.pro_descuento
            this.tabProducto.pro_stock = tr.pro_stock
            this.tabProducto.pro_stockCalmed = tr.pro_stockCalmed
            this.tabProducto.pro_deposito = tr.pro_deposito
            this.tabProducto.pro_depositoCalmed = tr.pro_depositoCalmed
            this.tabProducto.pro_costo = tr.pro_costo
            this.tabProducto.pro_peso = tr.pro_peso
            this.tabProducto.id_serie = tr.id_serie
            this.tabProducto.idlibro = tr.idlibro
            this.tabProducto.year = tr.year
            this.tabProducto.sumainicial = tr.sumainicial
            this.tabProducto.valornuevosumado = tr.valornuevosumado
            this.tabProducto.calculoaplicara_pro_reservar = tr.calculoaplicara_pro_reservar
            this.tabProducto.pro_reservar_anterior = tr.pro_reservar_anterior
            this.tabProducto.id_pro_codigo_padre = tr.id_pro_codigo_padre
            this.tabProducto.grupo_codigo_para_v3 = tr.grupo_codigo_para_v3
            this.errorPadreEditar = false
            this.errorGrupoV3Editar = false
        },
        editar() {
            let me = this;
            const usuariorespo = localStorage.getItem("usuario");
            const usuarioObjeto = JSON.parse(usuariorespo);
            const numeros = this.tabProducto.pro_codigo.replace(/\D/g, '');
            // VALIDAR STOCK Y DEPÓSITO
            let pro_reservar = 0;
            // Verificación y ajuste de pro_deposito
            if (this.tabProducto.pro_deposito === 0 || this.tabProducto.pro_deposito === '') {
                this.tabProducto.pro_deposito = 0;
            } else {
                this.tabProducto.pro_deposito = parseFloat(this.tabProducto.pro_deposito);
            }

            // Verificación y ajuste de pro_depositoCalmed
            if (this.tabProducto.pro_depositoCalmed === 0 || this.tabProducto.pro_depositoCalmed === '') {
                this.tabProducto.pro_depositoCalmed = 0;
            } else {
                this.tabProducto.pro_depositoCalmed = parseFloat(this.tabProducto.pro_depositoCalmed);
            }

            // Verificación y ajuste de pro_stock
            if (this.tabProducto.pro_stock === 0 || this.tabProducto.pro_stock === '') {
                this.tabProducto.pro_stock = 0;
            } else {
                this.tabProducto.pro_stock = parseFloat(this.tabProducto.pro_stock);
            }

            // Verificación y ajuste de pro_stockCalmed
            if (this.tabProducto.pro_stockCalmed === 0 || this.tabProducto.pro_stockCalmed === '') {
                this.tabProducto.pro_stockCalmed = 0;
            } else {
                this.tabProducto.pro_stockCalmed = parseFloat(this.tabProducto.pro_stockCalmed);
            }
            // Calcular pro_reservar como la suma de todas las variables
            this.tabProducto.valornuevosumado = (Number(this.tabProducto.pro_stock) || 0) +
                (Number(this.tabProducto.pro_stockCalmed) || 0) +
                (Number(this.tabProducto.pro_deposito) || 0) +
                (Number(this.tabProducto.pro_depositoCalmed) || 0);
            this.calculoaplicara_pro_reservar = this.tabProducto.valornuevosumado - this.tabProducto.sumainicial;
            pro_reservar = this.tabProducto.pro_reservar_anterior + this.calculoaplicara_pro_reservar;
            // console.log("tabProducto", this.calculoaplicara_pro_reservar);
            if (numeros == 0 || numeros == '') {
                this.tabProducto.year = 0
            } else {
                this.tabProducto.year = numeros;
            }
            if (this.tabProducto.pro_codigo === '' || this.tabProducto.pro_codigo === null) {
                me.$vs.notify({
                    text: 'Escriba el código del Vendedor antes de editar',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            console.log(this.tabProducto.gru_pro_codigo, "grupo codigo");
            if (this.tabProducto.gru_pro_codigo === '' || this.tabProducto.gru_pro_codigo === null) {
                me.$vs.notify({
                    text: 'Seleccione un grupo antes de editar',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if (this.validarCampoSerie()) {
                console.log('El campo de serie está lleno. Puedes continuar con el guardado.');
            } else {
                me.$vs.notify({
                    text: 'El campo de serie está vacío. No puedes continuar con el guardado.',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
                return;
            }
            if (this.tabProducto.grupo_codigo_para_v3 != 1) {
                // validamos que tabProducto.id_pro_codigo_padre no este vacio
                if (this.tabProducto.id_pro_codigo_padre == '' || this.tabProducto.id_pro_codigo_padre === null || this.tabProducto.id_pro_codigo_padre == undefined) {
                    this.errorPadreEditar = true;
                    this.$forceUpdate();
                    this.$nextTick(() => {
                      me.$vs.notify({
                          text: 'Seleccione el producto padre antes de editar',
                          color: 'danger',
                          iconPack: 'feather',
                          icon: 'icon-alert-triangle'
                      });
                    });
                    return;
                } else {
                    this.errorPadreEditar = false;
                }
            }
            if(this.tabProducto.grupo_codigo_para_v3 == '' || this.tabProducto.grupo_codigo_para_v3 === null){
              this.errorGrupoV3Editar = true;
              this.$forceUpdate();
              this.$nextTick(() => {
                me.$vs.notify({
                    text: 'Ingrese el grupo para v3 antes de editar',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                });
              });
              return;
            } else {
              this.errorGrupoV3Editar = false;
            }
            if (this.tabProducto.gru_pro_codigo === 1 || this.tabProducto.gru_pro_codigo === 3 || this.tabProducto.gru_pro_codigo === 6 || this.tabProducto.gru_pro_codigo === '1') {
                let datos = {
                    "pro_codigo": this.tabProducto.pro_codigo,
                    "pro_codigo_antiguo": this.pro_codigo_antiguo,
                    "gru_pro_codigo": this.tabProducto.gru_pro_codigo,
                    "pro_nombre": this.tabProducto.pro_nombre,
                    "pro_descripcion": this.tabProducto.pro_descripcion,
                    "pro_iva": this.tabProducto.pro_iva,
                    "pro_valor": parseFloat(this.tabProducto.pro_valor),
                    "pro_descuento": parseFloat(this.tabProducto.pro_descuento),
                    "pro_reservar": parseFloat(pro_reservar),
                    "pro_stock": parseFloat(this.tabProducto.pro_stock),
                    "pro_deposito": parseFloat(this.tabProducto.pro_deposito),
                    "pro_stockCalmed": parseFloat(this.tabProducto.pro_stockCalmed),
                    "pro_depositoCalmed": parseFloat(this.tabProducto.pro_depositoCalmed),
                    "pro_costo": parseFloat(this.tabProducto.pro_costo),
                    "pro_peso": parseFloat(this.tabProducto.pro_peso),
                    "nombrelibro": this.tabProducto.pro_nombre,
                    "nombre_imprimir": this.tabProducto.pro_nombre,
                    "descripcionlibro": this.tabProducto.pro_descripcion,
                    "idlibro": this.tabProducto.idlibro,
                    "id_serie": this.tabProducto.id_serie,
                    "codigo_liquidacion": this.tabProducto.pro_codigo,
                    "year": parseInt(this.tabProducto.year),
                    "version2": parseInt(this.tabProducto.year),
                    "user_created": usuarioObjeto.idusuario,
                    "id_pro_codigo_padre": this.tabProducto.id_pro_codigo_padre,
                    "grupo_codigo_para_v3": this.tabProducto.grupo_codigo_para_v3
                }
                // console.log(datos, "datos a enviar");
                // return;
                me.$vs.loading()
                //axios.post(this.$apifacturacion_url + 'f_Vendedor', datos)
                this.$http.post(this.$server_url + 'Registrar_modificar_producto', datos)
                    // this.$http.post(this.$server_url+'guardarLibro', datos2)
                    .then(res => {
                        me.$vs.loading.close()
                        //this.getProducto();
                        if (me.valorBusqueda == 0 || me.valorBusqueda == 1) {
                            this.getProductoParametro();
                        } else if (me.valorBusqueda == 2) {
                            this.getProductos_inactivos();
                        } else if (me.valorBusqueda == 3) {
                            this.getProductos_stockminimo();
                        }

                        me.$vs.notify({
                            text: res.data.message || 'Producto guardado con éxito',
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        });

                        this.errorPadreGuardar = false;
                        this.errorPadreEditar = false;
                        this.popupActivoEditar = false;
                        this.popupActivoDesactivar = false;
                        this.popupActivoGuardar = false;
                        this.popupActivoEliminar = false;
                    })
                    .catch(function () {
                        me.$vs.loading.close();
                        const errorMsg = err.response && err.response.data && err.response.data.message ?
                            err.response.data.message :
                            'Producto no se pudo guardar';
                        me.$vs.notify({
                            text: errorMsg,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x'
                        });
                    })
            } else {
                // console.log("dos");
                if (this.id_serie_antiguo == 1 || this.id_serie_antiguo == 3 || this.id_serie_antiguo == 6) {
                    me.$vs.notify({
                        text: 'No tiene permitido cambiar de grupo',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-triangle'
                    });
                    return;
                } else {
                    let datos = {
                        "pro_codigo": this.tabProducto.pro_codigo,
                        "gru_pro_codigo": this.tabProducto.gru_pro_codigo,
                        "pro_codigo_antiguo": this.pro_codigo_antiguo,
                        "pro_nombre": this.tabProducto.pro_nombre,
                        "pro_descripcion": this.tabProducto.pro_descripcion,
                        "pro_iva": this.tabProducto.pro_iva,
                        "pro_valor": parseFloat(this.tabProducto.pro_valor),
                        "pro_reservar": parseFloat(pro_reservar),
                        "pro_descuento": parseFloat(this.tabProducto.pro_descuento),
                        "pro_stock": parseFloat(this.tabProducto.pro_stock),
                        "pro_deposito": parseFloat(this.tabProducto.pro_deposito),
                        "pro_stockCalmed": parseFloat(this.tabProducto.pro_stockCalmed),
                        "pro_depositoCalmed": parseFloat(this.tabProducto.pro_deposito),
                        "pro_costo": parseFloat(this.tabProducto.pro_costo),
                        "pro_peso": parseFloat(this.tabProducto.pro_peso),
                        'id_pro_codigo_padre': this.tabProducto.id_pro_codigo_padre,
                        "grupo_codigo_para_v3": this.tabProducto.grupo_codigo_para_v3,
                    }
                    // console.log(datos, "datos3 a enviar");
                    // return;
                    me.$vs.loading()
                    //axios.post(this.$apifacturacion_url + 'f_Vendedor', datos)
                    this.$http.post(this.$server_url + 'Registrar_modificar_producto', datos)
                        .then(res => {
                            me.$vs.loading.close()
                            //this.getProducto();
                            this.getProductoParametro();

                            me.$vs.notify({
                                text: res.data.message || 'Producto guardado con éxito',
                                color: 'success',
                                iconPack: 'feather',
                                icon: 'icon-check'
                            });

                            this.errorPadreGuardar = false;
                            this.errorPadreEditar = false;
                            this.errorGrupoV3Guardar = false;
                            this.errorGrupoV3Editar = false;
                            this.popupActivoEditar = false;e;
                            this.errorGrupoV3Editar = false;
                            this.popupActivoEditar = false;
                            this.popupActivoDesactivar = false;
                            this.popupActivoGuardar = false;
                            this.popupActivoEliminar = false;
                        })
                        .catch(function () {
                            me.$vs.loading.close();
                            const errorMsg = err.response && err.response.data && err.response.data.message ?
                                err.response.data.message :
                                'Producto no se pudo guardar';
                            me.$vs.notify({
                                text: errorMsg,
                                color: 'danger',
                                iconPack: 'feather',
                                icon: 'icon-x'
                            });
                        })
                }
            }
        },
        popup_desactivar_activar_producto(tr) {
            this.popupActivoDesactivar = true
            this.pro_codigo = tr.pro_codigo
            this.tabProducto.pro_estado = tr.pro_estado
        },
        desactivar_activar_producto() {
            let me = this;
            let valornuevo = this.tabProducto.pro_estado;
            // console.log(valornuevo + 'valornuevoeatdoprocutp' + this.pro_codigo);
            if (valornuevo == 1) {
                valornuevo = 0;
                let datos = {
                    "pro_codigo": this.pro_codigo,
                    "pro_estado": valornuevo,
                }
                me.$vs.loading()
                //axios.post(this.$apifacturacion_url + 'f_Producto/AggOrUpdateProducto', datos)
                this.$http.post(this.$server_url + 'Desactivar_producto', datos)
                    .then(res => {
                        me.$vs.loading.close()
                        this.getProductoParametro();
                        me.$vs.notify({
                            text: 'Cambio de estado exitoso',
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        })
                        this.popupActivoEditar = false;
                        this.popupActivoDesactivar = false;
                        this.popupActivoGuardar = false;
                        this.popupActivoEliminar = false;
                    })
                    .catch(error => {
                        console.log(error);
                        me.$vs.loading.close()
                        me.$vs.notify({
                            text: 'No se pudo realizar el cambio de estado',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x'
                        })
                    })
            } else if (valornuevo == 0) {
                valornuevo = 1;
                let datos = {
                    "pro_codigo": this.pro_codigo,
                    "pro_estado": valornuevo,
                }
                me.$vs.loading()
                //axios.post(this.$apifacturacion_url + 'f_Producto/AggOrUpdateProducto', datos)
                this.$http.post(this.$server_url + 'Desactivar_producto', datos)
                    .then(res => {
                        me.$vs.loading.close()
                        this.getProductos_inactivos();
                        me.$vs.notify({
                            text: 'Cambio de estado exitoso',
                            color: 'success',
                            iconPack: 'feather',
                            icon: 'icon-check'
                        })
                        this.popupActivoEditar = false;
                        this.popupActivoDesactivar = false;
                        this.popupActivoGuardar = false;
                        this.popupActivoEliminar = false;
                    })
                    .catch(error => {
                        console.log(error);
                        me.$vs.loading.close()
                        me.$vs.notify({
                            text: 'No se pudo realizar el cambio de estado',
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-x'
                        })
                    })
            }

        },
        getPreguntaEliminar(tr) {
            this.popupActivoEliminar = true
            this.pro_codigo = tr.pro_codigo
            this.pro_nombre = tr.pro_nombre
            this.valorBusqueda = '0'
        },
        getEliminar() {
            let me = this;
            let datos = {
                "pro_codigo": this.pro_codigo,
                "pro_nombre": this.pro_nombre,
            }
            me.$vs.loading()
            this.$http.post(this.$server_url + "Eliminar_producto", datos)
                .then(data => {
                    me.$vs.loading.close()
                    //this.getProducto();
                    this.getProductoParametro();
                    me.$vs.notify({
                        text: 'Producto eliminado con exito',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })

                    this.popupActivoEditar = false;
                    this.popupActivoDesactivar = false;
                    this.popupActivoGuardar = false;
                    this.popupActivoEliminar = false;
                })
                .catch(function () {
                    me.$vs.loading.close()
                    me.$vs.notify({
                        text: 'Producto no se pudo eliminar',
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-x'
                    })
                })
        },
        getCancelar() {
            this.popupActivoEditar = false;
            this.popupActivoGuardar = false;
            this.popupActivoEliminar = false;
            this.popupActivoDesactivar = false;
        },
        exportarCombos() {
        let me = this;

        // Paso 1: Determinar el máximo número de productos en combos
        let maxProductosCombo = Math.max(
          ...me.Productos.map(p => (p.productosCombo ? p.productosCombo.length : 0))
        );

        // Paso 2: Crear encabezados
        let headers = ['Codigo', 'Nombre', 'Descripcion'];
        let fieldKeys = ['codigo', 'pro_nombre', 'descripcion'];

        for (let i = 1; i <= maxProductosCombo; i++) {
          headers.push(`Codigo${i}`);
          fieldKeys.push(`codigo${i}`);
        }

        // Paso 3: Crear datos planos
        let datosPlano = me.Productos.map(producto => {
          let objPlano = {
            codigo: producto.pro_codigo,
            pro_nombre: producto.pro_nombre,         // <- nuevo campo
            descripcion: producto.pro_descripcion,   // <- ya existente
          };

          if (producto.productosCombo && Array.isArray(producto.productosCombo)) {
            producto.productosCombo.forEach((item, idx) => {
              objPlano[`codigo${idx + 1}`] = `${item.pro_codigo} - ${item.pro_nombre}`;
            });
          }

          return objPlano;
        });

        // Paso 4: Exportar
        let nameFile = 'Reporte_Productos';
        me.m_exportTodo(headers, fieldKeys, datosPlano, nameFile);
      }



    },
    // created(){
    //     let url = "https://localhost:7252/api/Vendedor";
    //     axios.get(url).then((response) => this.Vendedores = response.data);
    //     // fetch("https://localhost:7252/api/Vendedor/")
    //     // .then(response => response.json())
    //     // .then((data) => (this.Vendedores = data));
    //     // // .then(data => (this.totalVuePackages = data.total));
    // }
}
</script>

<style scoped>
.text-red {
    color: red;
    font-weight: bold;
}

.text-orange {
    color: orange;
    font-weight: bold;
}

.text-green {
    color: green;
    font-weight: bold;
}

.bordeglosario {
    border: 1px solid #000;
    margin: 0px;
    padding: 0px;
}

.informacionformhijo {
    z-index: 51001;
    /* Asegúrate de que este valor sea alto para que el popup hijo del hijo pueda superponerse */
    /* position: fixed; */
    /* Asegúrate de que la posición sea adecuada */
}

.input-error {
    border: 2px solid red !important;
}

.input-error /deep/ .vs__control {
    border-color: red !important;
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.3) !important;
}

.input-error /deep/ .vs__dropdown-toggle {
    border: 2px solid red !important;
    box-shadow: 0 0 5px rgba(255, 0, 0, 0.3) !important;
}
</style>
